// @ts-ignore

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { wacToken } from "@/libraries/design/foundations";
import { Row } from "@/libraries/wpl/foundations/src";
import { LogoV3 } from "@/libraries/wpl/foundations/src";
import { TryPageHeader } from "@/templates/try/try-page/components";

import { TryPageCard } from "../../components/try-page-card";
import { messages } from "../messages";

const sectionStyles = css({
    padding: "32px 0",
    position: "relative",
    verticalAlign: "baseline",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%"
});

const IdentityAndSecuritySection = () => {
    const intl = useIntl();

    const atlassianAccessHeaderText = intl.formatMessage({
        id: "TryPageTemplate.IdentityAndSecurity.title",
        defaultMessage: "Identity & Security"
    });
    const headerProps = {
        headerText: atlassianAccessHeaderText,
        dividerColor: wacToken("color.primary.blue")
    };

    const atlassianAccessLink = "https://admin.atlassian.com/";
    const atlassianAccessBodyText = intl.formatMessage({
        id: "TryPageTemplate.identityAndSecurity.atlassianAccessBody",
        defaultMessage:
            "Gain company-wide visibility, security policies, and control across your Atlassian cloud infrastructure."
    });
    const tryCloud = intl.formatMessage(messages.tryCloud);

    const guardLogo = <LogoV3 brand={"guard"} type="logo" appearance="brand" />;

    const cardProps = {
        logo: guardLogo,
        link: atlassianAccessLink,
        bodyText: atlassianAccessBodyText,
        ctaText: tryCloud
    };

    return (
        <div css={sectionStyles}>
            <UFOSegment name={"identityAndSecurity"}>
                <Row>
                    <TryPageHeader {...headerProps} />
                </Row>
                <Row layout="6-6">
                    <TryPageCard {...cardProps} />
                    <div />
                </Row>
            </UFOSegment>
        </div>
    );
};

export default IdentityAndSecuritySection;
